export default "__VITE_ASSET__DHzORYaL__"